import { Fragment, Slice } from "prosemirror-model";
import { Plugin } from "prosemirror-state";
import { find, tokenize } from "linkifyjs";
import { normalizeLink, isAllowedUri, isValidLinkStructure } from "./utils";
export function linkifyPasteRule() {
    return new Plugin({
        props: {
            transformPasted: (slice) => {
                return new Slice(applyLinkify(slice.content), slice.openStart, slice.openEnd);
            },
        },
    });
}
function hasLinkMark(node) {
    return node.marks.some((mark) => mark.type.name === "link");
}
function applyLinkify(fragment, parent) {
    const linkified = [];
    fragment.forEach((child) => {
        // If the parent is a code block, skip linkifying and just return as-is
        if ((parent === null || parent === void 0 ? void 0 : parent.type.name) === "code_block") {
            linkified.push(child);
            return;
        }
        if (child.isText && hasLinkMark(child)) {
            // add to linkified directly and stop processing
            linkified.push(child);
            return;
        }
        if (child.isText) {
            const text = child.text;
            let pos = 0;
            const linkMark = child.type.schema.marks.link;
            const matches = find(text).filter((match) => match.isLink &&
                isValidLinkStructure(tokenize(match.value).map((t) => t.toObject("https"))) &&
                isAllowedUri(match.href));
            matches.forEach((match) => {
                const start = match.start;
                const end = match.end;
                // simply copy across the text from before the match
                if (start > pos) {
                    linkified.push(child.cut(pos, start));
                }
                const urlText = text.slice(start, end);
                const href = normalizeLink(urlText);
                if (isAllowedUri(href)) {
                    linkified.push(child
                        .cut(start, end)
                        .mark(linkMark.create({ href }).addToSet(child.marks)));
                }
                else {
                    linkified.push(child.cut(start, end));
                }
                pos = end;
            });
            // copy over whatever is left
            if (pos < text.length) {
                linkified.push(child.cut(pos));
            }
        }
        else {
            // Pass current child node as parent to recursion
            linkified.push(child.copy(applyLinkify(child.content, child)));
        }
    });
    return Fragment.fromArray(linkified);
}
